import React, { useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { Col, Row, Button, Modal, ModalBody, ModalHeader } from 'reactstrap';
import Layout from '../../../../components/Layout/Layout';
import Card from '../../../../components/Card/Card';
import TicketsList from '../../components/Tickets/TicketsList';
import Pagination from '../../../../components/Pagination/Pagination';
import LimitsHandler from '../../components/LimitsHandler/LimitsHandler';
import { LocalStorage } from '../../../../utils/utils';
import Icon from '../../../../components/Icon/Icon';
import TicketsListSettings from '../../components/Tickets/TicketsListSettings';

const limits = [50, 100, 250];

const TicketsPage = ({
  data: { loading, page, tickets, pageCount },
  cardHeaderRef,
  changePage,
  limit,
  handleLimitChange,
}) => {
  const saveSettings = (settings) => {
    LocalStorage.set('ticketsTableSettings', settings);
    changeSettings(settings);
  };

  const loadSettings = () => {
    const settings = LocalStorage.get('ticketsTableSettings');
    return settings
      ? settings
      : { id: true, created: true, title: true, status: true, answer: true };
  };

  const [tableSettings, changeSettings] = useState(loadSettings());
  const [settingsModalOpen, toggleSettingsModal] = useState(false);

  return (
    <Layout className="tickets-page" formattedTitle="pages.tickets.title">
      <Layout.Col>
        <h3 className="page-title">
          <FormattedMessage id="ticket.header.title" defaultMessage="Tickets" />
        </h3>
        <div className="page-alert tickets-page-alert">
          <p className="page-alert-text tickets-create-help">
            <FormattedMessage
              id="tickets.perhaps_answer"
              defaultMessage="Perhaps the answer to your question is already in the"
            />{' '}
            &nbsp;
            <Link to="/faq/">
              <FormattedMessage id="tickets.link_help_section" defaultMessage="help section" />
            </Link>
          </p>
        </div>

        <div className="tickets-page-controls">
          <Link to="/tickets/create" className="btn btn-primary">
            <FormattedMessage id="tickets.create_ticket" defaultMessage="Create Ticket" />
          </Link>
        </div>
        <Card loading={loading} innerRef={(el) => (cardHeaderRef = el)}>
          <Card.Header className="no-padding">
            <div className="tickets-controls">
              <div className="controls">
                <LimitsHandler
                  onChange={handleLimitChange}
                  value={limit}
                  limits={limits}
                  id="tickets-limits-header"
                />
                <Button
                  color="primary"
                  size="sm"
                  onClick={() => toggleSettingsModal(!settingsModalOpen)}
                >
                  <Icon type="kma-panel" tag="i" />
                </Button>
              </div>
              {pageCount > 1 && (
                <Pagination
                  pageCount={pageCount}
                  onPageChange={changePage}
                  activePage={page + 1}
                  scrollToAfterPageChanged={{
                    ref: cardHeaderRef,
                  }}
                  className="justify-content-end"
                />
              )}
            </div>
          </Card.Header>
          <Card.Body className="no-padding">
            {tickets.length > 0 ? (
              <TicketsList tableSettings={tableSettings} total={pageCount} tickets={tickets} />
            ) : (
              <div className="card-empty">
                <FormattedMessage id="tickets.no_tickets" defaultMessage="No Tickets" />
              </div>
            )}
          </Card.Body>
          <Card.Footer className="no-padding">
            <div className="tickets-controls">
              <div className="controls">
                <LimitsHandler
                  onChange={handleLimitChange}
                  value={limit}
                  limits={limits}
                  id="tickets-limits-header"
                />
                <Button
                  color="primary"
                  size="sm"
                  onClick={() => toggleSettingsModal(!settingsModalOpen)}
                >
                  <Icon type="kma-panel" tag="i" />
                </Button>
              </div>
              {pageCount > 1 && (
                <Pagination
                  pageCount={pageCount}
                  onPageChange={changePage}
                  activePage={page + 1}
                  scrollToAfterPageChanged={{
                    ref: cardHeaderRef,
                  }}
                  className="justify-content-end"
                />
              )}
            </div>
          </Card.Footer>
        </Card>
        <div className="tickets-page-controls">
          <Link to="/tickets/create" className="btn btn-primary">
            <FormattedMessage id="tickets.create_ticket" defaultMessage="Create Ticket" />
          </Link>
        </div>
      </Layout.Col>

      <Modal
        className="modal-logs-settings"
        isOpen={settingsModalOpen}
        toggle={() => toggleSettingsModal(!settingsModalOpen)}
        size="lg"
      >
        <ModalHeader>
          <FormattedMessage id="postback.logs.settings" defaultMessage="Customize fields" />
          <Button
            onClick={() => toggleSettingsModal(!settingsModalOpen)}
            close
            style={{ float: 'right' }}
          />
        </ModalHeader>
        <ModalBody>
          <TicketsListSettings
            toggleSettingsModal={() => toggleSettingsModal(!settingsModalOpen)}
            settings={tableSettings}
            saveSettings={saveSettings}
          />
          {/* <DomainListSettings toggleSettingsModal={toggleSettingsModal} settings={tableSettings} saveSettings={saveSettings} /> */}
          {/* <LogsTableSettings toggleLogsSettingsModal={this.toggleLogsSettingsModal} settings={settings} saveSettings={this.saveSettings} /> */}
        </ModalBody>
      </Modal>
    </Layout>
  );
};

export default TicketsPage;
